export class LocalizationManager
{
    static #currentLang = "en";

    static #dictionary = Object.assign(Object.create(null), {

        // Urls

        "user-agreement-url": {
            en: "/user-agreement-en.pdf",
            ru: "/user-agreement-ru.pdf"
        },
        "privacy-policy-url": {
            en: "/privacy-policy-en.pdf",
            ru: "/privacy-policy-ru.pdf"
        },

        // Page title terms

        "error-50x-page-title": {
            en: "Internal Server Error - Bannerlord Online",
            ru: "Произошла ошибка на сервере - Bannerlord Online",
            zh: "内部服务器错误 - Bannerlord Online"
        },
        "error-403-page-title": {
            en: "Access Denied - Bannerlord Online",
            ru: "Доступ запрещен - Bannerlord Online",
            zh: "拒绝访问 - Bannerlord Online"
        },
        "error-404-page-title": {
            en: "Page Not Found - Bannerlord Online",
            ru: "Страница не найдена - Bannerlord Online",
            zh: "页面未找到 - Bannerlord Online"
        },

        "cart-page-title": {
            en: "Cart - Bannerlord Online",
            ru: "Корзина - Bannerlord Online",
            zh: "购物车 - Bannerlord Online"
        },
        "discord-link-page-title": {
            en: "Discord Linking - Bannerlord Online",
            ru: "Привязка Discord - Bannerlord Online",
            zh: "Discord 绑定 - Bannerlord Online"
        },
        "shop-page-title": {
            en: "Shop - Bannerlord Online",
            ru: "Магазин - Bannerlord Online",
            zh: "商店 - Bannerlord Online"
        },
        "orders-page-title": {
            en: "Order History - Bannerlord Online",
            ru: "История заказов - Bannerlord Online",
            zh: "订单历史 - Bannerlord Online"
        },
        "order-result-page-title": {
            en: "Order Status - Bannerlord Online",
            ru: "Статус заказа - Bannerlord Online",
            zh: "订单状态 - Bannerlord Online"
        },
        "payment-status-widget-page-title": {
            en: "Payment Status - Bannerlord Online",
            ru: "Статус платежа - Bannerlord Online",
            zh: "支付状态 - Bannerlord Online"
        },

        // Payment provider terms

        "payment-provider-tbank": {
            en: "Credit or Debit Card (RU)",
            ru: "Оплата Картой или СБП (РФ)",
            zh: "信用卡或借记卡 (RU)"
        },
        "payment-provider-trybit": {
            en: "Cryptocurrency",
            ru: "Криптовалюта",
            zh: "加密货币"
        },

        "payment-provider-robokassa": {
            en: "Credit or Debit Card",
            ru: "Различные способы оплаты (РФ)",
            zh: "信用卡或借记卡"
        },

        "payment-provider-fastspring-credit-cart-or-paypal": {
            en: "Credit or Debit Card / PayPal",
            ru: "Оплата Картой / PayPal",
            zh: "信用卡或借记卡 / PayPal"
        },
        "payment-provider-fastspring-wechat-pay-or-alipay": {
            en: "WeChat Pay / Alipay",
            ru: "WeChat Pay / Alipay",
            zh: "微信支付 / 支付宝"
        },
        "payment-provider-fastspring-other": {
            en: "Other payment methods",
            ru: "Другие способы оплаты",
            zh: "其他支付方式"
        },

        // Terms

        "error-50x-title": {
            en: "Internal Server Error",
            ru: "Произошла ошибка на сервере",
            zh: "内部服务器错误"
        },
        "error-50x-body": {
            en: "Something went wrong on our end. Please try refreshing the page in a few minutes.",
            ru: "Попробуйте обновить страницу через несколько минут.",
            zh: "服务器发生错误。请几分钟后尝试刷新页面。"
        },
        "error-403-title": {
            en: "Access Denied",
            ru: "Доступ запрещен",
            zh: "拒绝访问"
        },
        "error-403-body": {
            en: "You do not have permission to access this page. Please log in to your account and try again.",
            ru: "У Вас нет доступа к этой странице, войдите в учетную запись пользователя и повторите попытку.",
            zh: "您没有权限访问此页面。请登录您的账户并重试。"
        },
        "error-404-title": {
            en: "Page Not Found",
            ru: "Страница не найдена",
            zh: "页面未找到"
        },
        "error-404-body": {
            en: "The requested content has been removed, or there is a typo in the URL.",
            ru: "Запрашиваемый контент был удален или допущена ошибка в адресе страницы.",
            zh: "请求的内容已被删除，或者网址有误。"
        },

        "main-text-1": {
            en: "Conquer a massive living world together",
            ru: "Покорите огромный живой мир вместе",
            zh: "一起征服庞大而生动的世界"
        },
        "main-text-2": {
            en: "Team up with friends for coop quests, engage in epic massive battles, and prove your dominance in ruthless PvP zones on a single server.",
            ru: "Объединяйтесь с друзьями для кооперативных заданий, участвуйте в эпических массовых битвах и доказывайте свое превосходство в беспощадных PvP-зонах на едином сервере.",
            zh: "与好友组队完成合作任务，参与史诗级的大型战役，并在单一服务器的无情PvP区域中证明你的统治力。"
        },
        "main-button-download-launcher": {
            en: "Download launcher",
            ru: "Скачать лаунчер",
            zh: "下载启动器"
        },

        "cookie_title": {
            en: "Cookies",
            ru: "Файлы cookie",
            zh: "Cookie"
        },
        "cookie_desc": {
            en: "We use cookies to enhance your experience. By clicking «Accept», you agree to our use of cookies and the processing of your personal data.",
            ru: "Мы используем файлы cookie, чтобы сайт стал лучше. Нажимая «Принять», вы соглашаетесь с использованием файлов cookie и обработкой персональных данных.",
            zh: "我们使用 Cookie 来提升您的体验。点击“接受”，即表示您同意我们使用 Cookie 并处理您的个人数据。"
        },
        "cookie_additional_desc_html": {
            en: 'This website uses cookies to ensure core functionality, analyze site traffic, and improve your browsing experience. We value your privacy. By clicking the «Accept» button, you acknowledge that you have read our <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" class="terms-link">Privacy Policy</a> and provide your informed consent to the processing of your personal data for these purposes.',
            ru: 'Наш сайт использует файлы cookie для обеспечения базовой функциональности, анализа трафика и улучшения пользовательского опыта. Мы бережно относимся к вашим данным. Нажимая кнопку «Принять», вы подтверждаете, что ознакомлены с нашей <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" class="terms-link">Политикой конфиденциальности</a> и даете осознанное согласие на обработку персональных данных для указанных целей.',
            zh: '本网站使用 Cookie 以确保核心功能正常运行、分析网站流量并改善您的浏览体验。我们非常重视您的隐私。点击“接受”按钮，即表示您确认已阅读我们的 <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" class="terms-link">隐私政策</a>，并同意为这些目的处理您的个人数据。'
        },
        "cookie_more": {
            en: "Learn more",
            ru: "Подробнее",
            zh: "了解更多"
        },
        "cookie_accept": {
            en: "Accept",
            ru: "Принять",
            zh: "接受"
        },
        "disclaimer_title": {
            en: "Disclaimer",
            ru: "Дисклеймер",
            zh: "免责声明"
        },
        "disclaimer_desc": {
            en: "Bannerlord Online is not affiliated with or endorsed by TaleWorlds Entertainment, or any other copyright holder. All used trademarks belong to their respective owners and are not affiliated with or endorsed by TaleWorlds Entertainment.",
            ru: "Bannerlord Online не связан и не поддерживается TaleWorlds Entertainment или любым другим правообладателем. Все используемые товарные знаки принадлежат их соответствующим владельцам и не связаны и не одобрены TaleWorlds Entertainment.",
            zh: "Bannerlord Online 与 TaleWorlds Entertainment 或任何其他版权所有者无关，也未获得其认可。所有使用的商标均属于其各自所有者，与 TaleWorlds Entertainment 无关也未获得其认可。"
        },

        "close_btn": {
            en: "Close",
            ru: "Закрыть",
            zh: "关闭"
        },

        "user-agreement": {
            en: "User Agreement",
            ru: "Пользовательское соглашение",
            zh: "用户协议"
        },
        "privacy-policy": {
            en: "Privacy Policy",
            ru: "Политика конфиденциальности",
            zh: "隐私政策"
        },

        "header-menu-start-game": {
            en: "Play Now",
            ru: "Начать игру",
            zh: "开始游戏"
        },
        "header-menu-forum": {
            en: "Forum",
            ru: "Форум",
            zh: "论坛"
        },
        "header-menu-shop": {
            en: "Shop",
            ru: "Магазин",
            zh: "商店"
        },
        "header-menu-discord": {
            en: "Discord",
            ru: "Discord",
            zh: "Discord"
        },

        "profile-guest-name": {
            "en": "Guest",
            "ru": "Гость",
            "zh": "访客"
        },
        "profile-menu-auth": {
            "en": "Login",
            "ru": "Авторизация",
            "zh": "登录"
        },
        "profile-menu-admin-panel-button": {
            "en": "Admin panel",
            "ru": "Панель администратора",
            "zh": "管理面板"
        },
        "profile-menu-register": {
            "en": "Register",
            "ru": "Регистрация",
            "zh": "注册"
        },
        "profile-menu-orders": {
            "en": "Order History",
            "ru": "История заказов",
            "zh": "订单历史"
        },
        "profile-menu-download-launcher": {
            "en": "Download Launcher",
            "ru": "Загрузка лаунчера",
            "zh": "下载启动器"
        },
        "profile-menu-logout": {
            "en": "Logout",
            "ru": "Выйти",
            "zh": "退出登录"
        },

        "nav-menu-home": {
            en: "Home",
            ru: "Главная",
            zh: "主页"
        },
        "nav-menu-shop": {
            en: "Shop",
            ru: "Магазин",
            zh: "商店"
        },
        "nav-menu-cart": {
            en: "Cart",
            ru: "Корзина",
            zh: "购物车"
        },
        "nav-menu-orders": {
            en: "Order History",
            ru: "История заказов",
            zh: "订单历史"
        },

        "shop-title": {
            en: "Shop",
            ru: "Магазин",
            zh: "商店"
        },
        "orders-title": {
            en: "Order History",
            ru: "История заказов",
            zh: "订单历史"
        },
        "cart-button": {
            en: "Cart",
            ru: "Корзина",
            zh: "购物车"
        },
        "clear-cart-button": {
            en: "Clear Cart",
            ru: "Очистить корзину",
            zh: "清空购物车"
        },
        "pay-button-terms": {
            en: `By clicking «Pay», you accept the terms of the <a href="/user-agreement" target="_blank" class="terms-link">Public Offer</a> and consent to the processing of personal data.`,
            ru: `Нажимая кнопку «Оплатить», вы принимаете условия <a href="/user-agreement" target="_blank" class="terms-link">Публичной оферты</a> и даете согласие на обработку персональных данных.`,
            zh: `点击“付款”即表示您接受 <a href="/user-agreement" target="_blank" class="terms-link">公开报价</a> 的条款，并同意处理您的个人数据。`
        },
        "pay-button": {
            en: "Pay",
            ru: "Оплатить",
            zh: "付款"
        },
        "cancel-payment-button": {
            en: "Cancel Payment",
            ru: "Отменить оплату",
            zh: "取消付款"
        },
        "home-page-button": {
            en: "Home Page",
            ru: "Главная страница",
            zh: "返回主页"
        },

        "discord-link-title": {
            en: "Linking Discord account...",
            ru: "Привязка аккаунта Discord...",
            zh: "正在绑定 Discord 账户..."
        },
        "discord-link-text": {
            en: "Please wait, we are linking your profile.",
            ru: "Пожалуйста, подождите, мы связываем ваш профиль.",
            zh: "请稍候，我们正在绑定您的个人资料。"
        },

        "order-table-order-id": {
            en: "Order ID",
            ru: "ID Заказа",
            zh: "订单 ID"
        },
        "order-table-order-date": {
            en: "Date",
            ru: "Дата",
            zh: "日期"
        },
        "order-table-order-description": {
            en: "Description",
            ru: "Описание",
            zh: "描述"
        },
        "order-table-order-total": {
            en: "Total",
            ru: "Итого",
            zh: "总计"
        },
        "order-product-item-activation-code-label": {
            en: "Key:",
            ru: "Код:",
            zh: "激活码："
        },
        "order-page-loading-state": {
            en: "Fetching your orders...",
            ru: "Идет загрузка заказов...",
            zh: "正在获取您的订单..."
        },
        "order-page-not-authorized-state": {
            en: "Please log in to view your order history.",
            ru: "Для просмотра истории заказов необходимо авторизоваться.",
            zh: "请登录以查看您的订单历史。"
        },
        "order-page-empty-state": {
            en: "No orders found.",
            ru: "Заказы не найдены.",
            zh: "未找到订单。"
        },
        "order-page-login-button": {
            en: "Login",
            ru: "Авторизация",
            zh: "登录"
        },
        "order-loading-failed-message": {
            en: "Failed to get orders! Error code: {0}",
            ru: "Не удалось загрузить список заказов. Код ошибки: {0}",
            zh: "无法获取订单！错误代码：{0}"
        },
        "order-code-copied": {
            en: "Key copied to clipboard!",
            ru: "Код скопирован в буфер обмена!",
            zh: "激活码已复制到剪贴板！"
        },
        "order-code-copy-failed": {
            en: "Failed to copy key to clipboard!",
            ru: "Не удалось скопировать код в буфер обмена!",
            zh: "无法复制激活码到剪贴板！"
        },

        "featured-products-text": {
            en: "You may also like these items",
            ru: "Возможно, вас заинтересуют другие товары",
            zh: "您可能也喜欢这些商品"
        },

        "confirmation-button-cancel": {
            en: "Cancel",
            ru: "Отмена",
            zh: "取消"
        },

        "cart-total-text": {
            en: "Total",
            ru: "Итого",
            zh: "总计"
        },
        "clear-cart-confirmation-title": {
            en: "Clear Cart",
            ru: "Удаление товаров",
            zh: "清空购物车"
        },
        "clear-cart-confirmation-body": {
            en: "Are you sure you want to remove all items from your cart?",
            ru: "Вы уверены, что хотите удалить все товары из корзины?",
            zh: "您确定要从购物车中移除所有商品吗？"
        },
        "clear-cart-confirmation-button-accept": {
            en: "Yes, remove all",
            ru: "Да, удалить",
            zh: "是的，全部移除"
        },
        "cart-loading-failed-message": {
            en: "Failed to load cart. Error code: {0}",
            ru: "Не удалось загрузить корзину. Код ошибки: {0}",
            zh: "无法加载购物车。错误代码：{0}"
        },
        "cart-changed-error-message": {
            en: "Your cart has been updated! Please try again.",
            ru: "Содержимое корзины изменилось! Попробуйте еще раз.",
            zh: "您的购物车已更新！请重试。"
        },
        "cart-item-have-invalid-price": {
            en: "Some items cannot be purchased in this currency!",
            ru: "Некоторые товары недоступны для покупки в выбранной валюте!",
            zh: "部分商品无法使用此货币购买！"
        },
        "cart-too-many-requests-error-message": {
            en: "Order creation limit exceeded. Please try again in 10 minutes.",
            ru: "Превышен лимит на создание заказов. Попробуйте через 10 минут.",
            zh: "超出订单创建限制。请在 10 分钟后重试。"
        },
        "cart-amount-too-large-error-message": {
            en: "Too many items selected. Please remove some items from your cart.",
            ru: "Выбрано слишком большое количество товаров, попробуйте удалить часть товаров из корзины.",
            zh: "选择的商品过多。请从购物车中移除部分商品。"
        },
        "payment-providers-not-available-for-selected-currency": {
            en: "No payment methods available for the selected currency!",
            ru: "Нет доступных способов оплаты для выбранной валюты!",
            zh: "所选货币没有可用的支付方式！"
        },
        "cart-not_supported_currency_with_payment_provider-error-message": {
            en: "Payment method not supported for this currency!",
            ru: "Выбранный способ оплаты не поддерживает указанную валюту!",
            zh: "该支付方式不支持此货币！"
        },
        "cart-common-error-message": {
            en: "Failed to create the order! Please try refreshing the page.\nError code: {0}",
            ru: "Не удалось создать заказ! Попробуйте обновить страницу.\nКод ошибки: {0}",
            zh: "创建订单失败！请尝试刷新页面。\n错误代码：{0}"
        },
        "cart-login-required-form-title": {
            en: "Sign In",
            ru: "Вход в учетную запись",
            zh: "登录"
        },
        "cart-login-required-form-body": {
            en: "You must be logged in to place an order",
            ru: "Для оформления заказа необходимо войти в учетную запись",
            zh: "您必须登录才能下订单"
        },
        "cart-login-required-form-button-accept": {
            en: "Sign In",
            ru: "Войти",
            zh: "登录"
        },

        "discord-error-ip-not-match": {
            en: "Try disabling VPN and make sure Bannerlord Online is running on the same computer as this browser.\nError code: {0}",
            ru: "Попробуйте отключить VPN и убедитесь, что Bannerlord Online запущен на том же компьютере, что и этот браузер.\nКод ошибки: {0}",
            zh: "请尝试禁用 VPN，并确保 Bannerlord Online 与当前浏览器在同一台计算机上运行。\n错误代码：{0}"
        },
        "discord-error-general": {
            en: "Try restarting the account linking process from the Bannerlord Online main menu.\nError code: {0}",
            ru: "Попробуйте заново запустить привязку аккаунта из главного меню Bannerlord Online.\nКод ошибки: {0}",
            zh: "请尝试从 Bannerlord Online 主菜单重新启动账户绑定过程。\n错误代码：{0}"
        },
        "discord-success-title": {
            en: "Success!",
            ru: "Успех!",
            zh: "成功！"
        },
        "discord-link-fail-title": {
            en: "Failed to link account!",
            ru: "Не удалось привязать аккаунт!",
            zh: "绑定账户失败！"
        },
        "discord-success-msg": {
            en: "Discord account authorized. You can close this window and return to Bannerlord Online to complete the linking process.",
            ru: "Discord аккаунт авторизован. Вы можете закрыть это окно и вернуться в Bannerlord Online для завершения процесса привязки.",
            zh: "Discord 账户已授权。您可以关闭此窗口并返回 Bannerlord Online 以完成绑定过程。"
        },

        "shop-loading-failed-error-message": {
            en: "Failed to load shop items, please try refreshing the page.\nError code: {0}",
            ru: "Не удалось загрузить товары магазина, попробуйте обновить страницу.\nКод ошибки: {0}",
            zh: "无法加载商店商品，请尝试刷新页面。\n错误代码：{0}"
        },

        "product-loading-failed-error-message": {
            en: "Failed to load product, please try refreshing the page.\nError code: {0}",
            ru: "Не удалось загрузить товар, попробуйте обновить страницу.\nКод ошибки: {0}",
            zh: "无法加载商品，请尝试刷新页面。\n错误代码：{0}"
        },

        "product-page-button-add-to-cart": {
            en: "add to cart",
            ru: "добавить в корзину",
            zh: "加入购物车"
        },
        "product-page-button-goto-to-cart": {
            en: "go to cart",
            ru: "перейти в корзину",
            zh: "去结算"
        },

        "order-result-page-orders-button": {
            "en": "Order History",
            "ru": "История заказов",
            "zh": "订单历史"
        },
        "order-result-page-login-button": {
            "en": "Login",
            "ru": "Авторизация",
            "zh": "登录"
        },
        "order-result-page-payment-confirmation-title": {
            en: "Order Payment Confirmation",
            ru: "Подтверждение оплаты заказа",
            zh: "订单付款确认"
        },
        "order-result-page-payment-confirmation-help-message": {
            en: `If your payment has not been confirmed within 10 minutes, please contact support via email:<br><a href="mailto:support@bannerlord-online.com">support@bannerlord-online.com</a>`,
            ru: `Если оплаченный заказ не был подтвержден в течение 10 минут, пожалуйста, обратитесь в поддержку по email:<br><a href="mailto:support@bannerlord-online.com">support@bannerlord-online.com</a>`,
            zh: `如果您的付款在 10 分钟内未得到确认，请通过电子邮件联系客服：<br><a href="mailto:support@bannerlord-online.com">support@bannerlord-online.com</a>`
        },
        "order-result-page-payment-success-title": {
            en: "Order successfully paid!",
            ru: "Заказ успешно оплачен!",
            zh: "订单付款成功！"
        },
        "order-result-page-payment-success-description": {
            en: 'To receive your items, open the premium window in the game and enter the activation key. Keys can be found in the <a href="/orders" target="_blank" rel="noopener noreferrer" class="terms-link">Order History</a>',
            ru: 'Для получения товаров откройте премиум окно в игре и введите ключ активации. Ключи можно найти в <a href="/orders" target="_blank" rel="noopener noreferrer" class="terms-link">Истории заказов</a>',
            zh: '要获取物品，请在游戏中打开高级窗口并输入激活码。激活码可以在<a href="/orders" target="_blank" rel="noopener noreferrer" class="terms-link">订单历史记录</a>中找到。'
        },
        "order-result-page-error-payment-failed-title": {
            en: "Order payment failed!",
            ru: "Не удалось оплатить заказ!",
            zh: "订单付款失败！"
        },
        "order-result-page-error-payment-failed-description": {
            en: "The payment system reported an error while processing your order.",
            ru: "Платежная система сообщила об ошибке оплаты заказа.",
            zh: "支付系统在处理您的订单时报错。"
        },
        "order-result-page-error-invalid-order-id-title": {
            en: "Failed to retrieve order information.",
            ru: "Не удалось получить информацию о заказе.",
            zh: "无法获取订单信息。"
        },
        "order-result-page-error-invalid-order-id-description": {
            en: "No Order ID provided. You may have been redirected to this page from a different browser.",
            ru: "ID заказа не указан. Возможно, Вы были перенаправлены на эту страницу из другого браузера.",
            zh: "未提供订单 ID。您可能是从其他浏览器被重定向到此页面的。"
        },
        "order-result-page-error-login-required-title": {
            en: "Login required!",
            ru: "Требуется вход в учетную запись!",
            zh: "需要登录！"
        },
        "order-result-page-error-login-required-description": {
            en: "Please log in to your account to view order status.",
            ru: "Для просмотра статуса заказов необходимо авторизоваться.",
            zh: "请登录您的账户以查看订单状态。"
        },
        "order-result-page-error-order-not-found-title": {
            en: "Failed to retrieve order information.",
            ru: "Не удалось получить информацию о заказе.",
            zh: "无法获取订单信息。"
        },
        "order-result-page-error-order-not-found-description": {
            en: "The specified Order ID could not be found in your current account. You may have been redirected to this page from a different browser.",
            ru: "Заказ с указанным ID не найден в текущей учетной записи. Возможно, Вы были перенаправлены на эту страницу из другого браузера.",
            zh: "在当前账户中找不到指定的订单 ID。您可能是从其他浏览器被重定向到此页面的。"
        },

        "payment-status-widget-success-title": {
            en: "Payment Successful",
            ru: "Оплата прошла успешно",
            zh: "支付成功"
        },
        "payment-status-widget-success-body": {
            en: "Thank you for your purchase! Your order has been paid successfully.",
            ru: "Спасибо за покупку! Ваш заказ успешно оплачен.",
            zh: "感谢您的购买！您的订单已成功付款。"
        },
        "payment-status-widget-success-button": {
            en: "Continue",
            ru: "Продолжить",
            zh: "继续"
        },
        "payment-status-widget-error-title": {
            en: "Order Not Paid",
            ru: "Заказ не оплачен",
            zh: "订单未付款"
        },
        "payment-status-widget-error-order-not-found": {
            en: "Order ID is missing. You may have been redirected to this page from a different browser.",
            ru: "ID заказа не указан. Возможно, Вы были перенаправлены на эту страницу из другого браузера.",
            zh: "未提供订单 ID。您可能是从其他浏览器被重定向到此页面的。"
        },
        "payment-status-widget-error-try-again-later": {
            en: "Please try again in a few minutes.",
            ru: "Попробуйте повторить попытку через несколько минут.",
            zh: "请在几分钟后重试。"
        },
        "payment-status-widget-error-button": {
            en: "Back to Store",
            ru: "Вернуться на страницу магазина",
            zh: "返回商店"
        }
    });

    static Init()
    {
        const langId = LocalizationManager.#GetCookie("xf_language_id");

        let langCode;

        switch (langId)
        {
            case "1":
                langCode = "en";
                break;
            case "2":
                langCode = "ru";
                break;
            case "3":
                langCode = "zh";
                break;
            default:
                langCode = "en";
                break;
        }

        LocalizationManager.#currentLang = langCode;
        document.documentElement.lang = langCode;

        LocalizationManager.#LocalizeAll();
    }

    static GetText(key, ...args)
    {
        const entry = LocalizationManager.#dictionary[key];

        let text = key;

        if (entry)
        {
            text = entry[LocalizationManager.#currentLang] || entry["en"] || key;
        }

        if (args && args.length > 0)
        {
            args.forEach((arg, index) => {
                text = text.replace(`{${index}}`, arg);
            });
        }

        return text;
    }

    static #LocalizeAll()
    {
        LocalizationManager.#LocalizeTree(document);

        const templates = document.querySelectorAll('template');
        templates.forEach(template => {
            LocalizationManager.#LocalizeTree(template.content);
        });
    }

    static #LocalizeTree(root)
    {
        const termElements = root.querySelectorAll('[data-term]');

        termElements.forEach(el => {
            const key = el.dataset.term;
            const translatedText = LocalizationManager.GetText(key);

            if (translatedText)
            {
                el.textContent = translatedText;
            }
            else
            {
                el.textContent = key;
            }
        });

        const htermElements = root.querySelectorAll('[data-hterm]');

        htermElements.forEach(el => {
            const key = el.dataset.hterm;
            const translatedText = LocalizationManager.GetText(key);

            if (translatedText)
            {
                el.innerHTML = translatedText;
            }
            else
            {
                el.textContent = key;
            }
        });
    }

    static #GetCookie(name)
    {
        const regex = new RegExp(`(?:(?:^|;\\s*)${name}=([^;]*))`);
        const match = document.cookie.match(regex);
        return match ? decodeURIComponent(match[1]) : null;
    }
}

document.addEventListener('DOMContentLoaded', LocalizationManager.Init);